import axios from 'axios';
import cookie from '../cookieHelper/cookie';

export default function editLogo(data, id) {
    console.table(data);
    // console.log(id);

    const API_URL = process.env.REACT_APP_BASE_URL + '/api/v1/company/logo/' + id;

    // Retrieve the authentication token from the cookie
    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);

    // Configuration object with the Authorization header
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };

    return (
        axios.post(API_URL, data, config)
        .then(res => {
            // console.log("res: ", res);
            return res.data;
        })
        .catch(err => {
            // console.log("err: ", err);
            return err;
        })
    );
}
